<div class="container-fluid g-0 container-summary">
    <h2 class="m-0">{{ 'fe_step5_summary_h2_title' | translate }}</h2>
</div>
<hr class="w-100 m-0 opacity-100 separator" />
<div
    class="container-fluid gx-11 mt-12 pb-0 container-summary container-summary-details"
>
    <div
        class="row mt-12 mb-12 flex-nowrap align-items-center container-summary-details-value"
    >
        <div class="col-auto">
            <img [src]="'images/car-front-sparkle-blue.svg' | cdn" alt="" />
        </div>
        <div
            [innerHTML]="
                getIncludesKey()
                    | translate
                    | replace: { protection: reservation.insurances[0]?.title }
            "
            class="col-12 gx-0 container-summary-details-value-message"
        ></div>
    </div>
</div>
<hr class="w-100 m-0 opacity-100 separator" />
<div class="container-fluid gx-11 container-summary container-summary-details">
    <div class="row mt-12 mb-12 container-summary-details-title">
        <div class="col-12">
            {{ 'fe_step5_summary_div_vehicle' | translate }}
        </div>
    </div>
    <div class="row mb-13 align-items-center">
        <div class="col-6">
            <div
                class="row fw-bold container-summary-details-title container-summary-details-title-v"
            >
                <div class="col">
                    {{ reservation.vehicle?.name }}
                </div>
            </div>
            <div class="row container-summary-details-value">
                <div class="col">{{ reservation.vehicle?.model }}</div>
            </div>
            <div
                class="row m4-15 container-summary-details-value container-summary-details-value-icons"
            >
                <div
                    class="d-flex align-items-center summary__features"
                    *ngIf="categoryFeatureIcons.length"
                >
                    <span
                        class="summary__feature"
                        *ngFor="let feature of categoryFeatureIcons"
                        [title]="feature.name"
                    >
                        <img [src]="feature.img" [alt]="feature.name" />
                        <ng-container
                            *ngIf="
                                feature.quantity !== null &&
                                feature.quantity !== undefined
                            "
                            >{{ feature.quantity }}</ng-container
                        >
                    </span>
                </div>
                <fe-car-features
                    *ngIf="
                        !categoryFeatureIcons.length &&
                        reservation?.vehicle?.features
                    "
                    [features]="reservation.vehicle.features"
                    [color]="'primary'"
                    [size]="'small'"
                ></fe-car-features>
            </div>
        </div>
        <div class="col-6">
            <img
                class="w-100"
                [src]="reservation.vehicle?.img"
                alt="selected vehicle"
            />
        </div>
        <fe-upgrade-promotion-summary
            *ngIf="isUpgradePromotion"
            [vehicle]="reservation.vehicle"
            [vehicleUpgrade]="vehicleUpgradePromotion"
        ></fe-upgrade-promotion-summary>
    </div>
</div>
<button
    (click)="onClickReservationDetails()"
    [ngClass]="{ opened: reservationDetailsOpened }"
    class="container-summary-collapse-btn w-100"
>
    <span>{{ 'fe_step5_summary_div_reservation-details' | translate }}</span>
    <svg viewBox="0 0 13.37 13.37" aria-hidden="true">
        <path
            d="M6.685,0A6.685,6.685,0,1,0,13.37,6.685,6.7,6.7,0,0,0,6.685,0Zm4.457,6.017-4.4,4.011H6.629l-4.4-3.955V6.017h0V5.961L3.51,4.512c.056-.056.111-.056.111,0L6.685,7.131,9.749,4.512a.077.077,0,0,1,.111,0l1.281,1.448Z"
            fill="#213b73"
        />
    </svg>
</button>
<div
    class="container-summary-collapse"
    [ngClass]="{ opened: reservationDetailsOpened }"
>
    <div
        class="container-fluid gx-11 container-summary container-summary-details"
    >
        <div class="row mt-12 mb-13 container-summary-details-title">
            <div class="col-12 text-uppercase">
                {{ 'fe_step5_summary_div_datetime' | translate }}
            </div>
        </div>
        <div class="row container-summary-details-subtitle">
            <div class="col-12">
                {{ 'fe_step5_summary_div_pickup' | translate }}
            </div>
        </div>
        <div class="row mb-14 container-summary-details-value">
            <div class="col-12">
                {{
                    reservation.startDatetime
                        | formatDate: dateFormatProgressBar
                }}
            </div>
        </div>
        <div class="row container-summary-details-subtitle">
            <div class="col-12">
                {{ 'fe_step5_summary_div_return' | translate }}
            </div>
        </div>
        <div class="row mb-12 container-summary-details-value">
            <div class="col-12">
                {{
                    reservation.endDatetime | formatDate: dateFormatProgressBar
                }}
            </div>
        </div>
        <hr class="w-100 m-0 opacity-100 separator" />
        <div class="row mt-12 mb-13 container-summary-details-title">
            <div class="col-12 text-uppercase">
                {{ 'fe_step5_summary_div_location-datetime' | translate }}
            </div>
        </div>
        <div
            [ngClass]="{
                'mb-14': !reservation.showDifferenteLocation
            }"
            class="row container-summary-details-value"
        >
            <div class="col-12">
                {{ reservation.locationName }}
            </div>
        </div>
        <div
            *ngIf="reservation.showDifferenteLocation"
            class="row mb-14 container-summary-details-value"
        >
            <div class="col-12">
                {{ reservation.differentLocationName }}
            </div>
        </div>
    </div>
</div>
<button
    (click)="onClickPaymentSummary()"
    [ngClass]="{ opened: paymentSummaryOpened }"
    class="container-summary-collapse-btn w-100"
>
    <span>{{ 'fe_step5_summary_div_payment-summary' | translate }}</span>
    <svg viewBox="0 0 13.37 13.37" aria-hidden="true">
        <path
            d="M6.685,0A6.685,6.685,0,1,0,13.37,6.685,6.7,6.7,0,0,0,6.685,0Zm4.457,6.017-4.4,4.011H6.629l-4.4-3.955V6.017h0V5.961L3.51,4.512c.056-.056.111-.056.111,0L6.685,7.131,9.749,4.512a.077.077,0,0,1,.111,0l1.281,1.448Z"
            fill="#213b73"
        />
    </svg>
</button>
<div
    class="container-summary-collapse"
    [ngClass]="{ opened: paymentSummaryOpened }"
>
    <div
        class="container-fluid gx-11 container-summary container-summary-details"
    >
        <button
            (click)="onClickCharges()"
            [ngClass]="{ opened: chargesOpened }"
            class="row gx-0 pt-12 pb-12 btn-taxes-details w-100 container-summary-details-title justify-content-between"
        >
            <div class="col-9">
                <div class="text-uppercase text-start fw-bold d-flex">
                    <div
                        class="d-inline-block justify-content-start align-items-center"
                    >
                        {{ getChargesTitleKey() | translate }}&nbsp;
                        <svg
                            class="chevron-collapse"
                            viewBox="0 0 13.37 13.37"
                            aria-hidden="true"
                        >
                            <path
                                d="M6.685,0A6.685,6.685,0,1,0,13.37,6.685,6.7,6.7,0,0,0,6.685,0Zm4.457,6.017-4.4,4.011H6.629l-4.4-3.955V6.017h0V5.961L3.51,4.512c.056-.056.111-.056.111,0L6.685,7.131,9.749,4.512a.077.077,0,0,1,.111,0l1.281,1.448Z"
                                fill="#8c4c9e"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="col-3 text-end">
                <span [showPlaceholder]="loadingSummary" fe-placeholder>
                    ${{
                        summaryService.summary?.subTotalAmount
                            | number: '1.2-2' : 'en-IN'
                    }}*
                </span>
            </div>
        </button>
        <div
            [style.max-height.px]="chargesOpened ? maxHeightCharges : 0"
            [ngClass]="{ opened: chargesOpened }"
            class="container-charges"
        >
            <ng-template
                ngFor
                let-attr
                let-index="index"
                [ngForOf]="summaryService.summary?.charges"
            >
                <div
                    *ngIf="attr.value !== undefined"
                    class="row gx-0 mb-0 container-summary-details-value justify-content-between flex-nowrap"
                >
                    <div class="col-9">{{ attr.name }}</div>
                    <div class="col-3 text-end">
                        ${{ attr.value | number: '1.2-2' : 'en-IN' }}*
                    </div>
                </div>
                <div
                    *ngIf="attr.value !== undefined"
                    class="row mb-12 container-summary-details-value justify-content-between flex-nowrap"
                >
                    <div class="col-auto">
                        {{ attr.quantity }}&nbsp;{{ attr.unit }} x ${{
                            attr.unitPrice | number: '1.2-2' : 'en-IN'
                        }}
                    </div>
                </div>
            </ng-template>
        </div>
        <hr
            *ngIf="
                summaryService.summary?.dropoff !== undefined &&
                summaryService.summary?.dropoff !== null
            "
            class="w-100 m-0 opacity-100 separator"
        />
        <div
            *ngIf="
                summaryService.summary?.dropoff !== undefined &&
                summaryService.summary?.dropoff !== null
            "
            class="row mt-12 mb-12 container-summary-details-title justify-content-between"
        >
            <div class="col-auto">
                <div class="btn-taxes-details text-uppercase fw-bold">
                    {{ 'fe_step5_summary_div_title-dropoff' | translate }}
                </div>
            </div>
        </div>
        <div
            *ngIf="
                summaryService.summary?.dropoff !== undefined &&
                summaryService.summary?.dropoff !== null
            "
            class="container-dropoff"
        >
            <div
                class="row mb-12 container-summary-details-value justify-content-between flex-nowrap"
            >
                <div class="col-7">
                    {{ summaryService.summary?.dropoff?.distance }} KM
                </div>
                <div class="col-5 text-end">
                    ${{
                        summaryService.summary?.dropoff?.value
                            | number: '1.2-2' : 'en-IN'
                    }}
                </div>
            </div>
        </div>
        <hr
            *ngIf="loadingSummary === true || maxHeightFees > 0"
            class="w-100 m-0 opacity-100 separator"
        />
        <button
            (click)="onClickFees()"
            [ngClass]="{ opened: feesOpened }"
            *ngIf="loadingSummary === true || maxHeightFees > 0"
            class="row gx-0 pt-12 pb-12 btn-taxes-details w-100 container-summary-details-title justify-content-between"
        >
            <div class="col-9">
                <div class="text-uppercase text-start fw-bold d-flex">
                    <div
                        class="d-inline-block justify-content-start align-items-center"
                    >
                        {{
                            'fe_step5_summary_div_title-fees' | translate
                        }}&nbsp;
                        <svg
                            class="chevron-collapse"
                            viewBox="0 0 13.37 13.37"
                            aria-hidden="true"
                        >
                            <path
                                d="M6.685,0A6.685,6.685,0,1,0,13.37,6.685,6.7,6.7,0,0,0,6.685,0Zm4.457,6.017-4.4,4.011H6.629l-4.4-3.955V6.017h0V5.961L3.51,4.512c.056-.056.111-.056.111,0L6.685,7.131,9.749,4.512a.077.077,0,0,1,.111,0l1.281,1.448Z"
                                fill="#8c4c9e"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="col-3 text-end">
                <span [showPlaceholder]="loadingSummary" fe-placeholder>
                    ${{
                        summaryService.summary?.totalFees
                            | number: '1.2-2' : 'en-IN'
                    }}*
                </span>
            </div>
        </button>
        <div
            [style.max-height.px]="feesOpened ? maxHeightFees : 0"
            [ngClass]="{ opened: feesOpened }"
            class="container-fees"
        >
            <ng-template
                ngFor
                let-attr
                let-index="index"
                [ngForOf]="summaryService.summary?.fees"
            >
                <div
                    *ngIf="attr.value !== undefined && attr.value > 0"
                    class="row gx-0 mb-12 container-summary-details-value justify-content-between"
                >
                    <div class="col-9">{{ attr.name }}</div>
                    <div class="col-3 text-end">
                        ${{ attr.value | number: '1.2-2' : 'en-IN' }}*
                    </div>
                </div>
            </ng-template>
        </div>
        <hr
            *ngIf="loadingSummary === true || maxHeightProducts > 0"
            class="w-100 m-0 opacity-100 separator"
        />
        <button
            (click)="onClickProducts()"
            [ngClass]="{ opened: productsOpened }"
            *ngIf="loadingSummary === true || maxHeightProducts > 0"
            class="row gx-0 pt-12 pb-12 btn-taxes-details w-100 container-summary-details-title justify-content-between"
        >
            <div class="col-8">
                <div
                    class="text-uppercase fw-bold d-flex justify-content-start align-items-center"
                >
                    {{ 'fe_step5_summary_div_title-extras' | translate }}&nbsp;
                    <svg
                        class="chevron-collapse"
                        viewBox="0 0 13.37 13.37"
                        aria-hidden="true"
                    >
                        <path
                            d="M6.685,0A6.685,6.685,0,1,0,13.37,6.685,6.7,6.7,0,0,0,6.685,0Zm4.457,6.017-4.4,4.011H6.629l-4.4-3.955V6.017h0V5.961L3.51,4.512c.056-.056.111-.056.111,0L6.685,7.131,9.749,4.512a.077.077,0,0,1,.111,0l1.281,1.448Z"
                            fill="#8c4c9e"
                        />
                    </svg>
                </div>
            </div>
            <div class="col-4 text-end">
                <span [showPlaceholder]="loadingSummary" fe-placeholder>
                    ${{
                        summaryService.summary?.subTotalProducts
                            | number: '1.2-2' : 'en-IN'
                    }}*
                </span>
            </div>
        </button>
        <div
            [style.max-height.px]="productsOpened ? maxHeightProducts : 0"
            [ngClass]="{ opened: productsOpened }"
            class="container-products"
        >
            <ng-template
                ngFor
                let-attr
                let-index="index"
                [ngForOf]="summaryService.summary?.products"
            >
                <div
                    *ngIf="attr.value !== undefined"
                    class="row gx-0 mb-0 container-summary-details-value justify-content-between"
                >
                    <div class="col-10">{{ attr.name }}</div>
                    <div class="col-2 text-end">
                        ${{ attr.value | number: '1.2-2' : 'en-IN' }}*
                    </div>
                </div>
                <div
                    *ngIf="attr.value !== undefined"
                    class="row mb-12 container-summary-details-value justify-content-between flex-nowrap"
                >
                    <div class="col-auto">
                        {{ attr.quantity }}&nbsp;{{ attr.unit }} x ${{
                            attr.unitPrice | number: '1.2-2' : 'en-IN'
                        }}
                    </div>
                </div>
            </ng-template>
        </div>
        <hr
            *ngIf="
                loadingSummary === true ||
                (summaryService.summary?.subTotalTaxes ?? 0) > 0
            "
            class="w-100 m-0 opacity-100 separator"
        />
        <button
            (click)="onClickTaxes()"
            [ngClass]="{ opened: taxesOpened }"
            *ngIf="
                loadingSummary === true ||
                (summaryService.summary?.subTotalTaxes ?? 0) > 0
            "
            class="row gx-0 pt-12 pb-12 btn-taxes-details w-100 container-summary-details-title justify-content-between"
        >
            <div class="col-9">
                <div class="text-uppercase text-start fw-bold d-flex">
                    <div
                        class="d-inline-block justify-content-start align-items-center"
                    >
                        {{
                            'fe_step5_summary_div_title-taxes' | translate
                        }}&nbsp;
                        <svg
                            class="chevron-collapse"
                            viewBox="0 0 13.37 13.37"
                            aria-hidden="true"
                        >
                            <path
                                d="M6.685,0A6.685,6.685,0,1,0,13.37,6.685,6.7,6.7,0,0,0,6.685,0Zm4.457,6.017-4.4,4.011H6.629l-4.4-3.955V6.017h0V5.961L3.51,4.512c.056-.056.111-.056.111,0L6.685,7.131,9.749,4.512a.077.077,0,0,1,.111,0l1.281,1.448Z"
                                fill="#8c4c9e"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="col-3 text-end">
                <span [showPlaceholder]="loadingSummary" fe-placeholder>
                    ${{
                        summaryService.summary?.subTotalTaxes
                            | number: '1.2-2' : 'en-IN'
                    }}*
                </span>
            </div>
        </button>
        <div [ngClass]="{ opened: taxesOpened }" class="container-taxes">
            <div
                class="row mb-12 container-summary-details-value justify-content-between flex-nowrap"
            >
                <div class="col-9">
                    {{ 'fe_step5_summary_div_title-tua' | translate }}
                </div>
                <div class="col-3 text-end ps-0">
                    <span [showPlaceholder]="loadingCart" fe-placeholder>
                        ${{
                            cartService.cart?.subTotalTUA
                                | number: '1.2-2' : 'en-IN'
                        }}*
                    </span>
                </div>
            </div>
            <div
                class="row mb-12 container-summary-details-value justify-content-between flex-nowrap"
            >
                <div class="col-9">
                    {{ 'fe_step5_summary_div_title-iva' | translate }}
                </div>
                <div class="col-3 text-end ps-0">
                    <span [showPlaceholder]="loadingCart" fe-placeholder>
                        ${{
                            cartService.cart?.subTotalIVA
                                | number: '1.2-2' : 'en-IN'
                        }}*
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid gx-11 container-summary container-summary-details">
    <hr class="w-100 m-0 opacity-100 separator" *ngIf="paymentSummaryOpened" />
    <div class="row mt-12 mb-15 container-summary-details-title">
        <div class="col-12">
            {{ 'fe_step5_summary_div_coupons' | translate }}
        </div>
    </div>
    <div class="row mb-12 container-summary-details-value">
        <div *ngIf="cartService.cart?.promotion?.status !== 1" class="col-12">
            {{ 'fe_step5_summary_div_withtou-coupons' | translate }}
        </div>
        <ng-container *ngIf="cartService.cart?.promotion?.status === 1">
            <div class="col">
                {{ cartService.cart?.promotion.codigo }}
            </div>
            <div
                *ngIf="couponPercentage > 0"
                class="col-auto text-end container-summary-coupon-percentage"
            >
                -{{ couponPercentage }}%
            </div>
        </ng-container>
    </div>
    <hr class="w-100 m-0 opacity-100 separator" />
    <div
        class="row mt-12 mb-12 container-summary-details-value container-summary-saving justify-content-between flex-nowrap"
        *ngIf="
            loadingSummary === true ||
            (summaryService.summary?.discount ?? 0) > 0
        "
    >
        <div class="col-8 d-flex align-items-center">
            <img [src]="'images/percentage.svg' | cdn" alt="discount" />
            &nbsp;
            <span>{{ 'fe_step5_summary_div_title-saving' | translate }}</span>
        </div>
        <div class="col-4 text-end">
            <span [showPlaceholder]="loadingSummary" fe-placeholder>
                ${{
                    summaryService.summary?.discount | number: '1.2-2' : 'en-IN'
                }}
            </span>
        </div>
    </div>
</div>
<div
    class="container-fluid gx-11 container-summary container-summary-details container-summary-total"
>
    <div
        class="row mb-15 justify-content-between container-summary-details-title container-summary-details-title-total flex-nowrap"
    >
        <div class="col-7">
            {{ getTotalTitleKey() | translate }}
        </div>
        <div class="col-5 text-end">
            <span [showPlaceholder]="loadingSummary" fe-placeholder>
                ${{
                    summaryService.summary?.totalAmount
                        | number: '1.2-2' : 'en-IN'
                }}
                {{ reservation.current.currency }}</span
            >
        </div>
    </div>
    <div
        class="row container-summary-details-value container-summary-details-value-extra"
    >
        <div class="col-auto">
            {{ 'fe_step5_summary_div_title-information' | translate }}
        </div>
    </div>
</div>
<hr class="w-100 m-0 opacity-100 separator" />
<div class="container-fluid gx-11 container-summary container-summary-details">
    <div class="row mt-12 mb-13 container-summary-details-title">
        <div class="col-12">
            {{ 'fe_step5_summary_div_title-cancelation-return' | translate }}
        </div>
    </div>
    <div
        class="row mt-12 mb-4 flex-nowrap align-items-center container-summary-details-value"
    >
        <div class="col-auto">
            <img [src]="'images/carx.svg' | cdn" alt="" />
        </div>
        <div class="col-12 gx-0 container-summary-details-value-message">
            {{ 'fe_step5_summary_div_info-cancelation-return' | translate }}
        </div>
    </div>
</div>
